import { Box, Card, CardContent, Divider, Grid, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorCoupons } from "services/vendorDashboard";


export default function VendorCoupons({vendorId}) {
  
  const { enqueueSnackbar } = useSnackbar();
  const [coupons, setCoupons] = useState(null);

  const getCoupons = useCallback((vendorId) => {
    getVendorCoupons({}, {}, {vendorId}).then(({response, error}) => {
      if(response){
        setCoupons(response);
      } else {
        setCoupons([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(vendorId){
      getCoupons(vendorId);
    }
  }, [getCoupons, vendorId]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate >
        <Grid container columnSpacing={4} rowSpacing={2} >
          {(coupons || []).map((coupon, index) => (
            <Grid className='coupon-card-container' item xs={10} sm={6} md={6} xl={3} lg={4} key={index} >
              <Card className="coupon-card" sx={{ px:2, py: 1, height: '180px', position: 'relative', boxShadow: 'none', }}>
                <CardContent>
                  <Typography gutterBottom variant="h4" component="div"  sx={{p: 0, m:0, lineHeight: 1, color: '#fcfcfc'}}>
                    -{coupon.discountPercent} %
                  </Typography>
                  <Typography gutterBottom variant="h6" component="div"  sx={{color: '#fcfcfc', textAlign: 'right'}}>
                    {coupon.code}
                  </Typography>
                  <Divider sx={{color : '#fff', borderStyle: 'dashed', borderColor: '#fff', position: 'absolute',top: '90px',left: 0,right: 0,margin: '0 22px'}} />
                  <Box sx={{position: 'absolute',  px:2, py: 1,  bottom: 0, left: 0, right: 0 }}>
                    <Typography component="div" variant="subtitle1" color="text.secondary" sx={{ color : '#fff', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}}> 
                      {coupon.description}
                    </Typography>
                    <Typography component="div" variant="subtitle2" color="text.secondary" sx={{ color: '#784900', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}}> 
                      Valid till {coupon.validityEndDate}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {coupons?.length === 0 ? (
            <Typography color="error" variant="h5" component="h5"> No data found</Typography>
          ): null}
        </Grid>
      </Box>
    </Paper>
  );
}
